export const mainFieldKeys = [
  'expCategory',
  'expType',
  'expDate',
  'currency',
  'amount',
  'taxAmount',
  'exptaxRecover',
  'expRate',
  'reimburAmt',
  'remarks',
  'acctCode',
  'baseRate',
  'baseAmt',
];
